import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import uniqueId from 'lodash/uniqueId';
import { MatDialog } from '@angular/material/dialog';
import { TextService } from '../../db-text/text.service';

import { UcrSecurityService } from '../ucr-security/ucr-security.service';
import { SwitchUserComponent } from '../switch-user/switch-user.component';
import { UserInfo } from '../ucr-security/user-info';
import { Roles } from '../ucr-security/roles';

@Component({
    selector: 'app-header-menu',
    templateUrl: 'header-menu.component.html',
    styleUrls: ['header-menu.component.scss']
})
export class HeaderMenuComponent implements OnInit, AfterViewInit {
    @Input() disableCheckEditText: boolean;
    @Output() mayEditTextEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    id: string = uniqueId('sm');
    logInButtonText = 'Sign Out'; // ucrSecurity.isLoggedIn ? 'Sign Out' : 'Sign In'
    roles = Roles;
    userInfo: UserInfo;
    mayEditTextComponents: boolean = false;
    toggleTextEditText: string = 'Enable Text Editing';

    constructor(public ucrSecurity: UcrSecurityService, public dialog: MatDialog, private textService: TextService) {
        this.ucrSecurity.onLoggedInStatusChanged.subscribe((loggedIn: boolean) => {
            this.logInButtonText = loggedIn ? 'Sign Out' : 'Sign In';
        });

        this.ucrSecurity.getUserInfo().subscribe((ui: UserInfo) => {
            this.userInfo = ui;

            if (ui.isSwitched) {

                this.logInButtonText = 'Switch Back';
            }

            this.initializeSmartMenu();
            this.checkTextEditing();


        });
    }
    private smartmenuInitialized = false;

    initializeSmartMenu(): void {
        if (!this.smartmenuInitialized) {
            this.smartmenuInitialized = true;
            ($(`#${this.id}`) as any).smartmenus({
                mainMenuSubOffsetX: 0,
                mainMenuSubOffsetY: 0,
                subMenusSubOffsetX: 0,
                subMenusSubOffsetY: 0
            });
        }
    }

    ngAfterViewInit(): void {
        if (this.userInfo) {
            this.initializeSmartMenu();
        }


    }

    ngOnInit(): void {
        //
    }

    openSwitchUserDialog(): void {
        this.dialog.open(SwitchUserComponent, {
            width: '50vw'
        });
    }

    signOutIn(): void {
        if (this.userInfo.isSwitched) {
            this.ucrSecurity.switchBack();
        } else {
            if (this.ucrSecurity.isLoggedIn) {
                this.ucrSecurity.logout();
            } else {
                this.ucrSecurity.login();
            }
        }
    }

    checkTextEditing() {
        console.log(this.disableCheckEditText);
        if (this.disableCheckEditText) {
            return;
        }
        if (this.userInfo?.ifAnyGranted([Roles.siteAdmin, Roles.registrarAdmin])) {
            this.textService.mayEditAny().subscribe({
                next: (v) => {
                    this.textService.currentlyEditing().subscribe((w) => {
                        this.mayEditTextComponents = v?.status === 200;
                        this.toggleTextEditText = w?.status === 200 ? 'Disable Text Editing' : 'Enable Text Editing';
                        this.mayEditTextEvent.emit(w?.status === 200);
                        // if app admin set to true
                        if(this.userInfo?.ifAnyGranted([Roles.switchUser])){
                            this.mayEditTextComponents = true;
                        }
                    });

                },
                error: () => {
                    //silent
                }
            });
        }

    }

    toggleTextEditing() {
        this.textService.toggleEditingMode().subscribe(() => {
            this.checkTextEditing();
        });
    }
}
